import type { FaireProductEntity } from "../../entity_types/product";

export const p_r9w24xycy9: FaireProductEntity = {
  token: "p_r9w24xycy9",
  type: "product",
  name: "Sea Salt & Orchid Bar Soap: Coastal Tranquility",
  brandName: "570 Soap Company",
  imageUrl:
    "https://cdn.faire.com/fastly/de24d6ebb58bb84f19ec1e499a5ca06b5a8da299ca2942e7041479148d0b3f88.jpeg",
  priceDollars: 4.2,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/33d5612a9e46b5621220b3d1d80f75ab3bd448c3fe5dc5398ddefe4a47b65e92.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
